export default {
  buttons: {
    change_plan: 'Cambiar plan',
  },
  toasts: {
    failed_to_load_data: 'Error al cargar los datos',
    failed_to_save_changes: 'Error al guardar los cambios',
  },
};
